<template>
  <div class="popupContainer">
    <div class="mt8p">
      <DxButtonGroup
        :items="statusBtns"
        styling-mode="outlined"
        :selected-item-keys="selectedFilter"
        key-expr="text"
        @item-click="filterByStatus"
      ></DxButtonGroup>
    </div>
    <div id="channelStatus">
      <div class="CustomGrid" v-if="LoadGrid">
        <DxDataGrid
          ref="channelStatusGrid"
          :data-source="NonCcrChannelStatusDS"
          :show-borders="false"
          :width="100 + '%'"
          :showColumnLines="true"
          :wordWrapEnabled="true"
          :headerFilter="{ visible: false }"
          @toolbar-preparing="onToolbarPreparing"
          :onContentReady="onContentReady"
          :rowAlternationEnabled="true"
          :remote-operations="false"
          :onExporting="onExporting"
          :onExported="onExported"
        >
          <DxPager
            :show-page-size-selector="true"
            :allowed-page-sizes="[5, 10, 20, 50]"
            :show-info="true"
          />
          <DxPaging :page-size="10" />
          <DxFilterRow :visible="true" />
          <DxHeaderFilter :visible="true" />
          <DxSearchPanel :visible="true" placeholder="Search..." :width="250" />
          <DxColumn
            data-field="CurrentStatusID"
            caption="CurrentStatusID"
            alignment="left"
            data-type="Number"
            :width="0"
          />
          <DxColumn
            data-field="MarketID"
            caption="MarketID"
            alignment="left"
            data-type="Number"
            :width="0"
          />
          <DxColumn
            data-field="ChannelName"
            caption="Channel"
            alignment="left"
            data-type="string"
            :allowHeaderFiltering="false"
            cell-template="ChannelCellTemplate"
          />
          <DxColumn
            data-field="AffiliationName"
            caption="Affiliation"
            alignment="left"
            data-type="string"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            data-field="MarketID"
            caption="MarketID"
            alignment="left"
            data-type="number"
            :allowHeaderFiltering="false"
            :visible="false"
          />
          <DxColumn
            data-field="ChannelStatus"
            caption="Channel Status"
            alignment="left"
            data-type="string"
            width="200"
            :visible="false"
          />
          <DxColumn
            data-field="Downtime"
            caption="Status"
            alignment="left"
            data-type="number"
            :allowHeaderFiltering="false"
            cell-template="statusTemplate"
            sortOrder="desc"
          />
          <DxColumn
            data-field="DigitalChannelNumber"
            caption="RF Channel#"
            alignment="left"
            data-type="string"
            :allowHeaderFiltering="false"
          />
          <DxColumn
            v-if="clientReferenceColumnName && clientReferenceColumnName != ''"
            data-field="ClientReferenceValue"
            caption=""
            alignment="left"
            data-type="string"
            :allowHeaderFiltering="false"
            header-cell-template="clientReferenceHeaderTemplate"
          />
          <template #statusTemplate="cell">
            <div>
              <font-awesome-icon
                :style="{ color: cell.data.data.StatusHexcolor }"
                icon="circle"
              />
              <span style="padding-left: 5px">{{
                cell.data.data.ChannelStatus
              }}</span>
            </div>
          </template>
          <DxColumn
            data-field="IncidentEventID"
            caption="Event ID"
            alignment="left"
            data-type="number"
            :allowHeaderFiltering="false"
            cell-template="EventIdCellTemplate"
          />
          <template #UnderlinedText="cell">
            <u> {{ cell.data.value }} </u>
          </template>
          <template #EventIdCellTemplate="cell">
            <div>
              <span v-if="cell.data.value">
                <span v-if="$route.name == 'Market dashboard'">
                  <router-link
                    :to="{
                      name: `Market Dashboard Event to Event Details`,
                      params: {
                        id: cell.data.data.MarketID,
                        eventId: cell.data.data.IncidentEventID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.data != null"
                      style="text-decoration: underline; cursor: pointer"
                      :title="`${
                        cell.data.data.IncidentEventID
                          ? cell.data.data.IncidentEventID
                          : ''
                      }`"
                    >
                      {{ cell.data.data.IncidentEventID }}
                    </span>
                  </router-link>
                </span>
                <span v-else-if="$route.name == 'Events To Dashboard'">
                  <router-link
                    :to="{
                      name: `Events To Event Details via Dashboard`,
                      params: {
                        id: cell.data.data.MarketID,
                        eventId: cell.data.data.IncidentEventID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.data != null"
                      style="text-decoration: underline; cursor: pointer"
                      :title="`${
                        cell.data.data.IncidentEventID
                          ? cell.data.data.IncidentEventID
                          : ''
                      }`"
                    >
                      {{ cell.data.data.IncidentEventID }}
                    </span>
                  </router-link>
                </span>
                <span
                  v-else-if="$route.name == 'Home Channels to Market Dashboard'"
                >
                  <router-link
                    :to="{
                      name: `Channels Dashboard to Event Details`,
                      params: {
                        id: cell.data.data.MarketID,
                        eventId: cell.data.data.IncidentEventID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.data != null"
                      style="text-decoration: underline; cursor: pointer"
                      :title="`${
                        cell.data.data.IncidentEventID
                          ? cell.data.data.IncidentEventID
                          : ''
                      }`"
                    >
                      {{ cell.data.data.IncidentEventID }}
                    </span>
                  </router-link>
                </span>
                <span
                  v-else-if="
                    $route.name == 'Events To Dashboard via Event Details'
                  "
                >
                  <router-link
                    :to="{
                      name: `Event to Event Details`,
                      params: {
                        eventId: cell.data.data.IncidentEventID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.data != null"
                      style="text-decoration: underline; cursor: pointer"
                      :title="`${
                        cell.data.data.IncidentEventID
                          ? cell.data.data.IncidentEventID
                          : ''
                      }`"
                    >
                      {{ cell.data.data.IncidentEventID }}
                    </span>
                  </router-link> </span
                ><span v-else>
                  <router-link
                    :to="{
                      name: `Event Details`,
                      params: {
                        eventId: cell.data.data.IncidentEventID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.data != null"
                      style="text-decoration: underline; cursor: pointer"
                      :title="`${
                        cell.data.data.IncidentEventID
                          ? cell.data.data.IncidentEventID
                          : ''
                      }`"
                    >
                      {{ cell.data.data.IncidentEventID }}
                    </span>
                  </router-link>
                </span></span
              >
            </div>
          </template>
          <template #ChannelCellTemplate="cell">
            <div style="display: flex">
              <span v-if="chartLocation == 'home'">
                <router-link
                  :to="{
                    name: 'Home TO Channel Details',
                    params: {
                      instanceId: cell.data.data.ProductInstanceID,
                    },
                  }"
                >
                  <span
                    v-if="cell.data.value != null"
                    style="text-decoration: underline; cursor: pointer"
                    @click="redirectToChannelDetails(cell.data.data)"
                  >
                    <span>
                      <ChannelNamePopup
                        :channelNamePopupRowData="cell.data.data"
                        :displayChannelName="cell.data.data.ChannelName"
                        :channelNameType="`ChannelVerification`"
                    /></span>
                  </span>
                </router-link>
              </span>
              <span v-else>
                <span v-if="$route.name == 'Home Channels to Market Dashboard'">
                  <router-link
                    :to="{
                      name: 'Channels Dashboard to Channel Details',
                      params: {
                        id: cell.data.data.MarketID,
                        instanceId: cell.data.data.ProductInstanceID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.value != null"
                      style="text-decoration: underline; cursor: pointer"
                      @click="redirectToChannelDetails(cell.data.data)"
                    >
                      <span>
                        <ChannelNamePopup
                          :channelNamePopupRowData="cell.data.data"
                          :displayChannelName="cell.data.data.ChannelName"
                          :channelNameType="`ChannelVerification`"
                      /></span>
                    </span>
                  </router-link>
                </span>
                <span v-else-if="$route.name == 'Market dashboard'">
                  <router-link
                    :to="{
                      name: 'Market Dashboard to Channel Details',
                      params: {
                        id: cell.data.data.MarketID,
                        instanceId: cell.data.data.ProductInstanceID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.value != null"
                      style="text-decoration: underline; cursor: pointer"
                      @click="redirectToChannelDetails(cell.data.data)"
                    >
                      <span>
                        <ChannelNamePopup
                          :channelNamePopupRowData="cell.data.data"
                          :displayChannelName="cell.data.data.ChannelName"
                          :channelNameType="`ChannelVerification`"
                      /></span>
                    </span>
                  </router-link>
                </span>
                <span v-else-if="$route.name == 'Events To Dashboard'">
                  <router-link
                    :to="{
                      name: 'Events To Channel Details via Dashboard',
                      params: {
                        id: cell.data.data.MarketID,
                        instanceId: cell.data.data.ProductInstanceID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.value != null"
                      style="text-decoration: underline; cursor: pointer"
                      @click="redirectToChannelDetails(cell.data.data)"
                    >
                      <span>
                        <ChannelNamePopup
                          :channelNamePopupRowData="cell.data.data"
                          :displayChannelName="cell.data.data.ChannelName"
                          :channelNameType="`ChannelVerification`"
                      /></span>
                    </span>
                  </router-link>
                </span>
                <span
                  v-else-if="
                    $route.name == 'Events To Dashboard via Event Details'
                  "
                >
                  <router-link
                    :to="{
                      name: 'Events To ChannelDetails via Event Details and Dashboard',
                      params: {
                        eventId: $route.params.eventId,
                        id: cell.data.data.MarketID,
                        instanceId: cell.data.data.ProductInstanceID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.value != null"
                      style="text-decoration: underline; cursor: pointer"
                      @click="redirectToChannelDetails(cell.data.data)"
                    >
                      <span>
                        <ChannelNamePopup
                          :channelNamePopupRowData="cell.data.data"
                          :displayChannelName="cell.data.data.ChannelName"
                          :channelNameType="`ChannelVerification`"
                      /></span>
                    </span>
                  </router-link>
                </span>
                <span v-else>
                  <router-link
                    :to="{
                      name: 'Home Events To Channel Details via Dashboard',
                      params: {
                        id: cell.data.data.MarketID,
                        instanceId: cell.data.data.ProductInstanceID,
                      },
                    }"
                  >
                    <span
                      v-if="cell.data.value != null"
                      style="text-decoration: underline; cursor: pointer"
                      @click="redirectToChannelDetails(cell.data.data)"
                    >
                      <span>
                        <ChannelNamePopup
                          :channelNamePopupRowData="cell.data.data"
                          :displayChannelName="cell.data.data.ChannelName"
                          :channelNameType="`ChannelVerification`"
                      /></span>
                    </span> </router-link
                ></span>
              </span>
            </div>
          </template>
          <template #CountryTemplate="cell">
            <span>
              {{ cell.data.data.Country }}
            </span>
          </template>
          <template #ClearBtn>
            <DxButton
              icon="fas fa-filter"
              hint="Clear All Filters"
              styling-mode="contained"
              :elementAttr="{ id: 'ClearAllBtn' }"
              :ref="'ClearAllBtnRef'"
              @click="clearDataGridFilters()"
              :disabled="!isFiltered"
            />
          </template>
          <template #clientReferenceHeaderTemplate>
            <div>{{ clientReferenceColumnName }}</div>
          </template>
        </DxDataGrid>
      </div>
      <DxLoadPanel
        :position="loaderPosition"
        :visible.sync="loaderVisible"
        :show-indicator="true"
        shading-color="rgba(0,0,0,0.4)"
      />
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxPager,
  DxHeaderFilter,
  DxSearchPanel,
  DxFilterRow,
} from "devextreme-vue/data-grid";
import { DxButton, DxButtonGroup } from "devextreme-vue";
import { DxLoadPanel } from "devextreme-vue/load-panel";
import "devextreme/data/odata/store";
import { EventBus } from "../../../../components/Events";
import ChannelNamePopup from "../../project/ChannelNamePopup.vue";
export default {
  name: "NonCCRChannelsStatusGrid",
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxFilterRow,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxButton,
    DxButtonGroup,
    DxLoadPanel,
    ChannelNamePopup,
  },
  data() {
    return {
      user: this.$auth.user.UserDetails,
      loaderVisible: false,
      loaderPosition: { of: "#channelStatus" },
      isFiltered: false,
      LoadGrid: false,
      statusBtns: [
        {
          text: `Up (${
            this.channelStatusPopupData.find((c) => c.type == "Up")?.count ?? 0
          })`,
          hint: "Up",
          filter: 1,
        },
        {
          text: `Down (${
            this.channelStatusPopupData.find((c) => c.type == "Down")?.count ??
            0
          })`,
          hint: "Down",
          filter: 2,
        },
        {
          text: `Unknown (${
            this.channelStatusPopupData.find((c) => c.type == "Unknown")
              ?.count ?? 0
          })`,
          hint: "Unknown",
          filter: 3,
        },
        {
          text: `All (${
            this.channelStatusPopupData.find((c) => c.type == "All")?.count ?? 0
          })`,
          hint: "Show All",
          filter: undefined,
        },
      ],
      selectedFilter: ["Up"],
      clientReferenceColumnName: "",
      firstLoad: true,
    };
  },
  props: {
    dmaID: Number,
    dmaNameAndRank: String,
    barClicked: String,
    chartLocation: String,
    MarketID: Number,
    channelStatusPopupData: Array,
  },
  computed: {
    NonCcrChannelStatusDS() {
      var company = this.$auth.user.UserDetails.Company_RecID;
      var MarketID = this.dmaID;
      var ContactCompany = this.$auth.user.UserDetails.Contact_Company_RecID;
      var token = this.$auth.user.UserDetails.id_token;
      return {
        store: {
          type: "odata",
          url: "https://api.ccr.net/ColoM360/ClientProductInstanceList_View",
          key: "CM_SiteChannel_RecID",
          version: 4,
          beforeSend: function (request) {
            let headers = {
              Authorization: `Bearer ${token}`,
            };
            if (ContactCompany != company) {
              headers["CompanyID"] = company;
            }
            request.headers = headers;
            let pth = request.url;
            if (pth[pth.length - 1] != ")") {
              if (request.params.$filter == undefined) {
                request.params.$filter =
                  "(Company_RecID eq " +
                  company +
                  // ") and (StatusID eq " +
                  // status +
                  ")";
              } else {
                request.params.$filter =
                  "(" +
                  request.params.$filter +
                  ") and (Company_RecID eq " +
                  company +
                  // ") and (StatusID eq " +
                  // status +
                  ")";
              }
              if (MarketID != undefined) {
                request.params.$filter =
                  request.params.$filter +
                  " and (MarketID eq " +
                  MarketID +
                  " and ProductPhase_ID eq 2)";
              }
            }
          },
          onLoaded: (data) => {
            this.clientReferenceColumnName = data[0]?.ClientReferenceID_Name;
          },
          errorHandler: (error) => {
            if (error.httpStatus == 401) {
              this.$auth.logout({ returnTo: `${window.location.origin}` });
            }
          },
        },
      };
    },
  },
  mounted: function () {
    let th = this;
    setTimeout(function () {
      th.LoadGrid = true;
    }, 100);
  },
  methods: {
    resetDMADashboard() {
      //reset DMA Details filter to Dashboard and not Project
      setTimeout(() => {
        EventBus.$emit("DMA-Filter", "Dashboard");
      }, 1);
    },
    redirectToChannelDetails(data) {
      this.$router.push({
        name: "Home To Channel Details via events",
        params: {
          instanceId: data.CM_SiteChannel_RecID,
          type: "ChannelName",
          ChannelName: data.ChannelName,
        },
      });
    },
    redirectToEventDetails(data) {
      this.$router.push({
        name: "Channel List to Events Details",
        params: { eventId: data.IncidentEventID },
      });
    },
    redirectToChannelDetails(data) {
      setTimeout(() => {
        EventBus.$emit("channel-status", data);
      }, 1);
    },
    filterByStatus(e) {
      var gridSelector = this.$refs["channelStatusGrid"].instance;
      let fltr = [];
      if (e.itemData.filter != undefined) {
        fltr = ["CurrentStatusID", "=", e.itemData.filter];
        gridSelector.filter(fltr);
      } else {
        this.clearDataGridFilters();
      }
    },
    onToolbarPreparing: function (e) {
      var toolbarItems = e.toolbarOptions.items;
      for (var i = 0; i < e.toolbarOptions.items.length; i++) {
        if (e.toolbarOptions.items[i].name == "searchPanel") {
          e.toolbarOptions.items[i].location = "before";
        }
      }
      var customButtons = [
        {
          location: "before",
          template: "ClearBtn",
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Export to Excel",
            icon: "fad fa-file-excel",
            onClick: this.ExportDataGrid.bind(this),
            elementAttr: { id: "ExcelBtn" },
          },
        },
        {
          location: "before",
          widget: "dxButton",
          options: {
            hint: "Refresh Grid",
            icon: "fad fa-sync",
            onClick: this.refreshDataGrid.bind(this),
            elementAttr: { id: "RefreshBtn" },
          },
        },
      ];
      toolbarItems.push(...customButtons);
    },
    onContentReady(e) {
      if (e.component.getCombinedFilter() == undefined) {
        this.isFiltered = false;
      } else {
        this.isFiltered = true;
      }
      if (this.firstLoad) {
        this.firstLoad = false;
        this.selectedFilter =
          this.barClicked == "Channels Up"
            ? ["Up (" + this.channelStatusPopupData[0].count + ")"]
            : ["Down (" + this.channelStatusPopupData[1].count + ")"];
        var gridSelector = this.$refs["channelStatusGrid"].instance;
        this.statusBtns.forEach((e) => {
          if (this.barClicked == e.hint) {
            this.selectedFilter = [e.text];
            gridSelector.filter(["CurrentStatusID", "=", e.filter]);
          }
        });
      }
      // if (this.firstLoad) {
      //   this.firstLoad = false;
      //   this.selectedFilter =
      //     this.barClicked == "Channels Up"
      //       ? ["Up (" + this.channelStatusPopupData[0] + ")"]
      //       : ["Down (" + this.channelStatusPopupData[1] + ")"];
      //   var gridSelector = this.$refs["channelStatusGrid"].instance;
      //   let fltr = [];
      //   fltr = ["StatusID", "=", this.barClicked == "Channels Up" ? 1 : 2];
      //   gridSelector.filter(fltr);
      // }
    },
    onExporting(e) {
      e.component.beginUpdate();
      e.component.columnOption("Impact Length", "visible", true);
      e.component.columnOption("Channel Status", "visible", true);

      e.component.columnOption("Status", "visible", false);
    },
    onExported(e) {
      e.component.columnOption("Impact Length", "visible", false);
      e.component.columnOption("Channel Status", "visible", false);
      e.component.columnOption("Status", "visible", true);
      e.component.endUpdate();
    },
    calculateStatusValue(rowData) {
      return rowData.Status.split(" ")[0];
    },
    calculateDownMinsValue(rowData) {
      return rowData.Status.split("for")[1];
    },
    refreshDataGrid() {
      this.$refs["channelStatusGrid"].instance.refresh();
    },
    ExportDataGrid() {
      this.$refs["channelStatusGrid"].instance.exportToExcel(false);
    },
    clearDataGridFilters() {
      this.$refs["channelStatusGrid"].instance.clearFilter();
      this.selectedFilter = [
        "All (" + this.channelStatusPopupData[2].count + ")",
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.mt8p {
  margin-top: 8px;
  text-align: left;
}
.dmaAndRank {
  text-align: left;
  font-weight: bold;
  color: grey;
}
#channelStatus::v-deep {
  .dx-datagrid .dx-column-indicators .dx-header-filter,
  .dx-datagrid .dx-sort-down,
  .dx-datagrid .dx-sort-up {
    color: grey;
  }
  .dx-datagrid-headers
    .dx-datagrid-table
    .dx-row
    > td
    .dx-datagrid-text-content {
    color: grey;
  }
}
.popupContainer {
  min-height: 585px;
  padding: 10px;
}
</style>